import type { TwelveMonthTrendDTO, TwelveMonthTrendMonthDTO } from "../models/twelveMonthTrendDto";
import type { TwelveMonthTrendEntity, TwelveMonthTrendMonthEntity } from "../../domain/entities/TwelveMonthTrendEntity";

function mapMonth(dto: TwelveMonthTrendMonthDTO): TwelveMonthTrendMonthEntity {
  const revenue = Number(dto.revenue) || 0;
  const ebitda = Number(dto.ebitda) || 0;
  return {
    year: dto.year ?? 0,
    month: dto.month ?? 0,
    monthLabel: dto.monthLabel ?? "",
    revenue,
    expenses: Number(dto.expenses) || 0,
    ebitda,
    ebitdaPercentage:
      dto.ebitdaPercentage != null
        ? Number(dto.ebitdaPercentage) || 0
        : revenue > 0
          ? (ebitda / revenue) * 100
          : 0,
    cashIn: Number(dto.cashIn) || 0,
    cashOut: Number(dto.cashOut) || 0,
  };
}

export function twelveMonthTrendDtoToEntity(dto: TwelveMonthTrendDTO): TwelveMonthTrendEntity {
  const mappedMonths = (dto.months ?? []).map(mapMonth);
  const monthCountRaw = dto.monthCount;
  const monthCount =
    typeof monthCountRaw === "number" && Number.isFinite(monthCountRaw)
      ? monthCountRaw
      : mappedMonths.length;

  return {
    fromMonth: dto.fromMonth ?? "",
    toMonth: dto.toMonth ?? "",
    monthCount,
    rangeLabel: typeof dto.rangeLabel === "string" ? dto.rangeLabel : "",
    months: mappedMonths,
  };
}
